const Option = () => null;
Option.isSelectOption = true;
Option.displayName = 'WdAutoCompleteOption';
export default Option;
